


const Comp_404 = () => {
  return (
    <div style={{ minHeight: '80vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#282c34' }}>
      <h1 style={{ fontSize: '6rem', margin: 0 }}>404</h1>
      <h2 style={{ fontWeight: 400, margin: '1rem 0' }}>Page Not Found</h2>
      <p>The page you are looking for does not exist or has been moved.</p>
    </div>
  );
}


export default Comp_404;